// extracted by mini-css-extract-plugin
export default {"menuBlock":"hF-z","title":"iF-z","nav":"jF-z","flexCell":"kF-z","facetLink":"lF-z"};